"use strict";

var _regeneratorRuntime = require("/codebuild/output/src400645628/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

var _clientAwsS = require("@devsta/client-aws-s3");

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _lodash = _interopRequireDefault(require("lodash.merge"));

var _reactRouterDom = require("react-router-dom");

require("url-search-params-polyfill");

var _basePath = _interopRequireDefault(require("../../../common/constants/basePath"));

var _EditOrganisationWizard = _interopRequireDefault(require("./EditOrganisationWizard"));

var _utils = require("../utils");

var _Organisation = _interopRequireDefault(require("../contexts/Organisation"));

var _organisationContext = _interopRequireDefault(require("../selectors/organisationContext"));

require("../styles/_organisation.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var NEW_ORGANISATION_LOCATION = "".concat(_basePath.default, "/organisations/edit/new");

function isNewOrganisation(_ref) {
  var pathname = _ref.location.pathname;
  return pathname === NEW_ORGANISATION_LOCATION;
}

function getRequestedStep(location) {
  if (!location.hash) {
    return 1;
  }

  return parseInt(location.hash.substring(1), 10);
}

function getInitialPageFromOrganisation(organisation, history) {
  var location = history.location;

  if (!organisation || !Object.keys(organisation).length) {
    return 1;
  }

  var requestedStep = getRequestedStep(location);
  var isValidStep = (0, _utils.isValidModifyOrganisationStep)(organisation, requestedStep);
  return isValidStep ? requestedStep : 1;
}

function shouldRedirectUser(organisation, location) {
  return organisation.organisationId && !(0, _utils.isValidModifyOrganisationStep)(organisation, getRequestedStep(location));
}

var EditOrganisationRoot = /*#__PURE__*/function (_Component) {
  _inherits(EditOrganisationRoot, _Component);

  function EditOrganisationRoot(props) {
    var _this;

    _classCallCheck(this, EditOrganisationRoot);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(EditOrganisationRoot).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "getViewableOrganisations", (0, _memoizeOne.default)(function (organisations) {
      return organisations.filter(function (singleOrganisation) {
        return singleOrganisation.name !== 'Shootsta';
      });
    }));

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var orgPermissions, hasUpdatePermission;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              orgPermissions = _this.props.orgPermissions;
              hasUpdatePermission = (0, _commonReact.hasPermission)('MANAGE_CUSTOMERS', orgPermissions);
              _context.next = 4;
              return Promise.all([_this.fetchOrganisation(), _this.fetchOrganisations()]);

            case 4:
              _this.setState({
                hasUpdatePermission: hasUpdatePermission,
                loading: false
              });

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "handleBack", function (backArgs) {
      var stage = backArgs.stage;
      var history = _this.props.history;
      var organisation = _this.state.organisation;

      var _ref3 = organisation || {},
          organisationId = _ref3.organisationId;

      if (!organisationId) {
        return void history.push('/organisations');
      }

      history.push((0, _utils.getModifyOrganisationUrl)(organisationId, stage));
    });

    _defineProperty(_assertThisInitialized(_this), "makeRequest", /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(request) {
        var _ref5,
            requiresOrganisationId,
            organisationId,
            _ref6,
            data,
            error,
            _args2 = arguments;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _ref5 = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {}, requiresOrganisationId = _ref5.requiresOrganisationId;
                organisationId = _this.props.organisationId;

                if (!(requiresOrganisationId && !organisationId)) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return", {
                  data: null,
                  error: null
                });

              case 4:
                _context2.next = 6;
                return request();

              case 6:
                _ref6 = _context2.sent;
                data = _ref6.data;
                error = _ref6.error;

                if (!error) {
                  _context2.next = 12;
                  break;
                }

                _this.setState({
                  error: error
                });

                return _context2.abrupt("return", {
                  data: null,
                  error: error
                });

              case 12:
                return _context2.abrupt("return", {
                  data: data,
                  error: error
                });

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x) {
        return _ref4.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "injectSignedImageIntoOrg", /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref7) {
        var organisation, apolloClient, organisationWithUrls;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                organisation = _ref7.organisation;
                apolloClient = _this.props.apolloClient;
                _context3.prev = 2;
                _context3.next = 5;
                return (0, _clientAwsS.replaceBucketKeysWithUrls)({
                  apiClient: apolloClient,
                  data: organisation,
                  substitutedKeys: ['imageUrl'],
                  organisationId: organisation.organisationId
                });

              case 5:
                organisationWithUrls = _context3.sent;
                return _context3.abrupt("return", organisationWithUrls);

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](2);
                return _context3.abrupt("return", organisation);

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[2, 9]]);
      }));

      return function (_x2) {
        return _ref8.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "fetchOrganisations", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var getOrganisations, _ref10, data, error, getOrganisationsData, shootstaOrganisation;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              getOrganisations = _this.props.getOrganisations;
              _context4.next = 3;
              return _this.makeRequest(getOrganisations);

            case 3:
              _ref10 = _context4.sent;
              data = _ref10.data;
              error = _ref10.error;

              if (!(!data || error)) {
                _context4.next = 8;
                break;
              }

              return _context4.abrupt("return");

            case 8:
              getOrganisationsData = data.getOrganisations;
              shootstaOrganisation = (0, _utils.getShootstaOrganisation)(getOrganisationsData);

              _this.setState({
                shootstaOrganisation: shootstaOrganisation,
                organisations: getOrganisationsData
              });

            case 11:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    })));

    _defineProperty(_assertThisInitialized(_this), "fetchOrganisation", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var getOrganisation, _ref12, data, error, organisation, organisationWithImage;

      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              getOrganisation = _this.props.getOrganisation;
              _context5.next = 3;
              return _this.makeRequest(getOrganisation, {
                requiresOrganisationId: true
              });

            case 3:
              _ref12 = _context5.sent;
              data = _ref12.data;
              error = _ref12.error;

              if (!error) {
                _context5.next = 8;
                break;
              }

              return _context5.abrupt("return");

            case 8:
              organisation = data && data.getOrganisation;

              if (organisation) {
                _context5.next = 11;
                break;
              }

              return _context5.abrupt("return", void _this.setState({
                organisation: organisation
              }));

            case 11:
              _context5.next = 13;
              return _this.injectSignedImageIntoOrg({
                organisation: organisation
              });

            case 13:
              organisationWithImage = _context5.sent;

              _this.setState({
                organisation: organisationWithImage
              });

            case 15:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    })));

    _defineProperty(_assertThisInitialized(_this), "conditionalUserRedirect", function () {
      var organisation = _this.state.organisation;
      var location = _this.props.history.location;

      if (!organisation || !shouldRedirectUser(organisation, location)) {
        return null;
      }

      return _react.default.createElement(_reactRouterDom.Redirect, {
        to: "".concat(_basePath.default).concat((0, _utils.getModifyOrganisationUrl)(organisation.organisationId, 1))
      });
    });

    _defineProperty(_assertThisInitialized(_this), "updateOrganisation", /*#__PURE__*/function () {
      var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref13) {
        var input, afterware, _this$props, updateOrganisation, createOrganisation, history, location, _this$state, organisation, organisations, _ref15, organisationId, defaultedOrganisations, _ref16, data, error, newOrgId, newOrganisation, organisationWithUpdatedImage, newOrganisations, organisationIndex;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                input = _ref13.input, afterware = _ref13.afterware;
                _this$props = _this.props, updateOrganisation = _this$props.updateOrganisation, createOrganisation = _this$props.createOrganisation, history = _this$props.history, location = _this$props.history.location;
                _this$state = _this.state, organisation = _this$state.organisation, organisations = _this$state.organisations;
                _ref15 = organisation || {}, organisationId = _ref15.organisationId;
                defaultedOrganisations = organisations || [];

                if (!(!Object.keys(input).length && organisationId)) {
                  _context6.next = 8;
                  break;
                }

                history.push((0, _utils.getModifyOrganisationUrl)(organisationId, getRequestedStep(location) + 1));
                return _context6.abrupt("return", {
                  data: {},
                  error: null
                });

              case 8:
                if (!organisationId) {
                  _context6.next = 14;
                  break;
                }

                _context6.next = 11;
                return updateOrganisation({
                  organisationId: organisationId,
                  input: input
                });

              case 11:
                _context6.t0 = _context6.sent;
                _context6.next = 17;
                break;

              case 14:
                _context6.next = 16;
                return createOrganisation(input);

              case 16:
                _context6.t0 = _context6.sent;

              case 17:
                _ref16 = _context6.t0;
                data = _ref16.data;
                error = _ref16.error;

                if (!(error || !data)) {
                  _context6.next = 22;
                  break;
                }

                return _context6.abrupt("return", {
                  data: data,
                  error: error
                });

              case 22:
                newOrgId = organisationId || data.createOrganisation.organisationId;
                newOrganisation = (0, _lodash.default)(organisation, _objectSpread({
                  organisationId: newOrgId
                }, input));

                if (!input.imageUrl) {
                  _context6.next = 30;
                  break;
                }

                _context6.next = 27;
                return _this.injectSignedImageIntoOrg({
                  organisation: newOrganisation
                });

              case 27:
                _context6.t1 = _context6.sent;
                _context6.next = 31;
                break;

              case 30:
                _context6.t1 = newOrganisation;

              case 31:
                organisationWithUpdatedImage = _context6.t1;
                newOrganisations = organisationId ? _toConsumableArray(defaultedOrganisations) : [].concat(_toConsumableArray(defaultedOrganisations), [organisationWithUpdatedImage]);

                if (organisationId) {
                  organisationIndex = defaultedOrganisations.findIndex(function (singleOrganisation) {
                    return singleOrganisation.organisationId === newOrgId;
                  });
                  newOrganisations.splice(organisationIndex, 1, organisationWithUpdatedImage);
                } // update local


                _context6.next = 36;
                return new Promise(function (resolve) {
                  _this.setState({
                    organisation: organisationWithUpdatedImage,
                    organisations: newOrganisations
                  }, resolve);
                });

              case 36:
                if (!afterware) {
                  _context6.next = 39;
                  break;
                }

                _context6.next = 39;
                return afterware({
                  organisationId: newOrgId
                });

              case 39:
                // change step
                history.push((0, _utils.getModifyOrganisationUrl)(newOrgId, getRequestedStep(location) + 1));
                return _context6.abrupt("return", {
                  data: data,
                  error: error
                });

              case 41:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function (_x3) {
        return _ref14.apply(this, arguments);
      };
    }());

    _this.state = {
      hasUpdatePermission: false,
      loading: true
    };
    return _this;
  }

  _createClass(EditOrganisationRoot, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          history = _this$props2.history,
          inviteUser = _this$props2.inviteUser,
          getOrganisationRoles = _this$props2.getOrganisationRoles;
      var _this$state2 = this.state,
          error = _this$state2.error,
          loading = _this$state2.loading,
          organisation = _this$state2.organisation,
          shootstaOrganisation = _this$state2.shootstaOrganisation,
          organisations = _this$state2.organisations,
          hasUpdatePermission = _this$state2.hasUpdatePermission;
      var filteredOrganisations = organisations ? this.getViewableOrganisations(organisations) : [];

      if (error) {
        return _react.default.createElement(_commonReact.Error, null);
      }

      if (organisation === null && !isNewOrganisation(history)) {
        return _react.default.createElement(_commonReact.NotFound, null);
      }

      if (loading) {
        return _react.default.createElement(_uiKit.Loader, null);
      }

      return _react.default.createElement(_Organisation.default.Provider, {
        value: (0, _organisationContext.default)({
          state: {
            organisation: organisation,
            organisations: filteredOrganisations,
            shootstaOrganisation: shootstaOrganisation,
            hasUpdatePermission: hasUpdatePermission
          },
          actions: {
            updateOrganisation: this.updateOrganisation,
            inviteUser: inviteUser,
            getOrganisationRoles: getOrganisationRoles
          }
        })
      }, _react.default.createElement(_uiKit.ClosablePage, {
        className: "organisation",
        history: history,
        backUrl: "/organisations"
      }, this.conditionalUserRedirect(), _react.default.createElement(_EditOrganisationWizard.default, {
        onBack: this.handleBack,
        initialStage: getInitialPageFromOrganisation(organisation, history)
      })));
    }
  }]);

  return EditOrganisationRoot;
}(_react.Component);

exports.default = EditOrganisationRoot;